@let activeUser = activeUser$ | async;
@if (activeUser) {
  <ul nz-menu nzMode="horizontal">

    <li nz-menu-item nzMatchRouter nzMatchRouterExact class="main-logo">
      <a [routerLink]="['/']">
        <img src="assets/FlaggrLogo.svg" alt="Flagger">
        <span>Flaggr</span>
      </a>
    </li>

    @if (activeUser.canEditOwnScopes || activeUser.canEditAnyUserScopes) {
      <li nz-menu-item nzMatchRouter>
        <a [routerLink]="['/me']">Me</a>
      </li>
    }

    @if (activeUser.canEditAnyUserScopes) {
      <li nz-menu-item nzMatchRouter>
        <a [routerLink]="['/users']">Users</a>
      </li>
    }

    @if (activeUser.canEditOwnScopes || activeUser.canEditAnyUserScopes) {
      <li nz-menu-item nzMatchRouter>
        <a [routerLink]="['/scopes']">Scopes</a>
      </li>
    }

    @if (activeUser.canEditOwnScopes || activeUser.canEditAnyUserScopes) {
      <li nz-menu-item nzMatchRouter>
        <a [routerLink]="['/tags']">Tags</a>
      </li>
    }

    @if (activeUser.canEditAnyUserScopes) {
      <li nz-menu-item nzMatchRouter>
        <a [routerLink]="['/audit']">Audit</a>
      </li>
    }

    <li nz-submenu [nzTitle]="activeUserMenuTitle" class="active-user-menu-item">
      <ng-template #activeUserMenuTitle>
        <span>{{ activeUser.displayName }}</span>
        <nz-avatar [nzShape]="'circle'" [nzSrc]="activeUser?.picture" />
      </ng-template>

      <ul>
        <li nz-menu-item (click)="onLogoutClick()">
          Logout
        </li>
      </ul>
    </li>

  </ul>
}
